// Module
var code = "<div class=\"widget-content relative\"> <wt-new-gauge class=\"flex-directive\" component-id=\"{{vm.id}}\" data=\"vm.data\" options=\"vm.options\"> </wt-new-gauge> </div>";
// Exports
module.exports = code;